import FadeIn from "@/components/FadeIn";
import { Database, Landmark, Scale, FileText } from "lucide-react";

const CARDS = [
  {
    icon: Database,
    title: "Transactions réelles DVF",
    text: "Les ventes effectivement enregistrées autour de votre adresse, issues des Demandes de Valeurs Foncières.",
  },
  {
    icon: Landmark,
    title: "Indicateurs des notaires",
    text: "Les tendances trimestrielles du marché parisien et francilien, par arrondissement et par type de bien.",
  },
  {
    icon: Scale,
    title: "Comparables récents",
    text: "Des biens similaires vendus dans votre rue ou votre quartier au cours des derniers mois.",
  },
  {
    icon: FileText,
    title: "Rapport documenté",
    text: "Date d'édition, adresse, historique, comparatifs et sources cités noir sur blanc — téléchargeable immédiatement.",
  },
];

export default function MethodSection() {
  return (
    <section id="methode" data-testid="method-section" className="border-t border-stone-800/60 bg-[#0e0e11]">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:py-32">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <FadeIn className="lg:col-span-5">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]/80">La méthode</p>
            <h2 className="font-display mt-4 text-2xl font-normal tracking-tight text-amber-100 sm:text-3xl lg:text-4xl">
              Une estimation <em className="text-[#D4AF37]">documentée,</em><br />
              pas une approximation.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-stone-400">
              DPE, surface, étage, nombre de pièces, calendrier de votre projet :
              chaque réponse affine le résultat. Votre rapport rassemble le jour et le mois
              d'édition, le code postal, la rue, les comparatifs et leurs sources.
            </p>
          </FadeIn>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-7">
            {CARDS.map((card, i) => (
              <FadeIn key={card.title} delay={i * 0.08}>
                <div
                  data-testid={`method-card-${i}`}
                  className="group h-full border border-stone-800 bg-[#141417] p-8 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
                >
                  <card.icon size={22} className="text-[#D4AF37]" strokeWidth={1.5} />
                  <h3 className="font-display mt-5 text-xl font-medium text-amber-200/90">{card.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-stone-400">{card.text}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
